'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _adminsByCategoryPie = require('./admins-by-category-pie.component');

var _adminsByCategoryPie2 = _interopRequireDefault(_adminsByCategoryPie);

var _adminsByCategoryPie3 = require('./admins-by-category-pie.service');

var _adminsByCategoryPie4 = _interopRequireDefault(_adminsByCategoryPie3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.reports.administrationsByCategoryPie', [_angularUiRouter2.default]).component('administrationsByCategoryPie', _adminsByCategoryPie2.default).service('AdminsByCategoryPieService', _adminsByCategoryPie4.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('administrationsByCategoryPie', {
    parent: 'reports',
    url: '/administrations-by-category-pie',
    component: 'administrationsByCategoryPie',
    data: {
      permissions: {
        only: [_roles.SYS_ADMIN],
        redirectTo: 'dashboard'
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-pie/admins-by-category-pie.module.js